import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import clsx from 'clsx';
//Material-UI
import makeStyles from '@material-ui/core/styles/makeStyles';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';

//ICONOS
import DeleteIcon from '@material-ui/icons/Delete';
import SendIcon from '@material-ui/icons/Send';

//COMPONENTES EXTERNOS
import MUIRichTextEditor from 'mui-rte';
import { convertToRaw } from 'draft-js';
import { draftToMarkdown } from 'markdown-draft-js';

//GRAPHQL
import gql from 'graphql-tag';
import { useMutation, useQuery } from '@apollo/react-hooks';

//DS
import { hooks, toast } from 'lib.front';
import { validacion, transformacion } from 'lib.common';
import { openMsg, loadingModal } from 'redux-app';

//ESQUEMAS
import { esquemaCampos, esquemaValidacion } from './esquemas';

const { useValidacion } = hooks;
const { esVarNullUndef } = validacion;
//Estilos del componente
const useStyles = makeStyles(theme => ({
   container: {
      marginTop: theme.spacing(1)
   },
   textField: {
      width: '100%'
   }
}));

/*
Funciones y variables auxiliares globales
*/
const rteDefaultValue = {
   key: 'vacio',
   contenido: ''
};

//Queries
const getData = gql`
   query TipoTicket {
      tiposTicket {
         codigo
         denominacion
         estructuraCamposAdicionales
      }
   }
`;

const guardarTicket = gql`
   mutation AgregarTicket(
      $codigo: String!
      $asunto: String!
      $camposAdicionales: JSON
      $prioridad: Int
      $tipoTicket: String!
      $cliente: String!
   ) {
      agregarTicket(
         codigo: $codigo
         asunto: $asunto
         camposAdicionales: $camposAdicionales
         prioridad: $prioridad
         tipoTicket: $tipoTicket
         cliente: $cliente
      ) {
         codigo
      }
   }
`;

const guardarTicketDetalle = gql`
   mutation AgregarTicketDetalle($ticket: String!, $descripcion: String!, $cliente: String) {
      agregarTicketDetalle(ticket: $ticket, descripcion: $descripcion, cliente: $cliente) {
         ticket {
            codigo
         }
      }
   }
`;

function AbrirTicket({ usuario, openMsgModal,
   openWaitModal }) {
   //Inicializar Estilos del componente
   const classes = useStyles();
   /*
  Inicializar estados
  */
   const { campos, existeError, handleOnChange, validacionManual, setCampo } = useValidacion(
      esquemaCampos,
      esquemaValidacion
   );

   /*
  Estados de control
  */
   const [tiposTicket, setTiposTicket] = useState([]);
   const [tipoDoc, setTipoDoc] = useState('');

   const [estadoRte, setEstadoRte] = useState(rteDefaultValue);
   function toggleRte() {
      if (estadoRte.key === 'vacio') {
         setEstadoRte({
            key: 'editando',
            content: ''
         });
      } else {
         setEstadoRte(rteDefaultValue);
      }
   }

   /*
  Estados de conexion a la API
  */
   const { loading: loadingQ, error: errorQ, data: dataQ } = useQuery(getData);
   const [agregarTicket, { loading: loadingT, error: errorT, data: dataT }] = useMutation(
      guardarTicket
   );
   const [agregarTicketDetalle, { loading: loadingTd, error: errorTd, data: dataTd }] = useMutation(
      guardarTicketDetalle
   );

   /*
  Efectos
  */
   //Inicializar con los datos del usuario actual
   useEffect(() => {
      if (usuario != undefined && usuario != null) {
         const tipoDocumento = usuario.tipoDoc;
         if (tipoDocumento === '6') {
            setCampo('nombre', usuario.razonSocial);
         } else {
            setCampo('nombre', `${usuario.nombre} ${usuario.apPaterno} ${usuario.apMaterno}`);
         }
         setTipoDoc(tipoDocumento);
         setCampo('email', usuario.email);
         setCampo('codCliente', usuario.codigo);
      }
   }, []);
   //Recuperar informacion estatica de base de datos
   useEffect(() => {
      if (!esVarNullUndef(dataQ)) {
         let dataAux = dataQ[Object.keys(dataQ)[0]];
         if (dataAux != null) {
            if (Array.isArray(dataAux) && dataAux.length > 0) {
               setTiposTicket(dataAux);
               setCampo('codTipoTicket', dataAux[0].codigo);
            }
         }
      }
   }, [dataQ]);

   useEffect(() => {
      if (!esVarNullUndef(dataT)) {
         if (dataT.agregarTicket != null) {
            agregarTicketDetalle({
               variables: {
                  ticket: dataT.agregarTicket.codigo,
                  descripcion: campos.descripcion.valor,
                  cliente: campos.codCliente.valor
               }
            });
         }
      }
   }, [dataT]);

   useEffect(() => {
      if (!esVarNullUndef(dataTd)) {
         if (dataTd.agregarTicketDetalle != null) {
            toast.showSuccess('Su ticket ha sido enviado satisfactoriamente! Por favor espere mientras revisamos su peticion.');
            inicializar();
         }
      }
   }, [dataTd]);

   //Manejo de errores de las consultas a la api
   useEffect(() => {
      let eMsg = '';
      if (!esVarNullUndef(errorQ)) {
         eMsg = eMsg + JSON.stringify(errorQ);
      }
      if (!esVarNullUndef(errorT)) {
         eMsg = eMsg + JSON.stringify(errorT);
      }
      if (!esVarNullUndef(errorTd)) {
         eMsg = eMsg + JSON.stringify(errorTd);
      }
      if (eMsg !== '') {
         openMsgModal(eMsg);
      }
   }, [errorQ, errorT, errorTd]);

   useEffect(() => {
      openWaitModal(loadingT || loadingTd || loadingQ);
   }, [loadingT, loadingTd, loadingQ]);
   /*
  Handlers
  */
   function editorChange(state) {
      const markdown = draftToMarkdown(convertToRaw(state.getCurrentContent()));
      setCampo('descripcion', markdown);
   }

   /*
  Funciones y Eventos
  */
   async function validarTodos() {
      let ok =
         (await validacionManual('email', campos.email.valor)) === '' &&
         (await validacionManual('asunto', campos.asunto.valor)) === '' &&
         (await validacionManual('descripcion', campos.descripcion.valor)) === '';
      return ok;
   }

   function onBlurValidacion(e) {
      validacionManual(e.target.name, e.target.value);
   }

   function inicializar() {
      setCampo('asunto', '');
      setCampo('camposAdicionales', null);
      setCampo('prioridad', 0);
      if (tiposTicket.length > 0) {
         setCampo('codTipoTicket', tiposTicket[0].codigo);
      }
      toggleRte();
   }

   const procesarGrabar = async () => {
      const ok = await validarTodos();
      if (ok) {
         const codigo = await transformacion.generarUuid(15);
         agregarTicket({
            variables: {
               codigo,
               asunto: campos.asunto.valor,
               camposAdicionales: campos.camposAdicionales.valor,
               prioridad: campos.prioridad.valor,
               tipoTicket: campos.codTipoTicket.valor,
               cliente: campos.codCliente.valor
            }
         });
      } else {
         toast.showError('Se han encontrado errores al validar los datos.');
      }
   };
   /*
  Returns
  */

   return (
      <Container className={clsx(classes.container)} maxWidth="md">
         <Grid container spacing={1}>
            <Grid item xs={12}>
               <Typography variant="h4" gutterBottom>
                  Abrir Ticket
               </Typography>
            </Grid>
            <Grid item xs={6}>
               <TextField
                  label={tipoDoc === '6' ? 'Razon Social' : 'Nombre'}
                  name="nombre"
                  variant="filled"
                  margin="dense"
                  className={clsx(classes.textField)}
                  InputProps={{
                     readOnly: true
                  }}
                  onChange={handleOnChange}
                  value={campos.nombre.valor}
                  error={campos.nombre.error !== ''}
                  helperText={campos.nombre.error}
               />
            </Grid>
            <Grid item xs={6}>
               <TextField
                  label="Dirección de Email"
                  name="email"
                  variant="filled"
                  margin="dense"
                  className={clsx(classes.textField)}
                  onChange={handleOnChange}
                  onBlur={onBlurValidacion}
                  value={campos.email.valor}
                  error={campos.email.error !== ''}
                  helperText={campos.email.error}
               />
            </Grid>
            <Grid item xs={8}>
               <TextField
                  label="Asunto"
                  name="asunto"
                  variant="filled"
                  margin="dense"
                  className={clsx(classes.textField)}
                  required
                  onChange={handleOnChange}
                  onBlur={onBlurValidacion}
                  value={campos.asunto.valor}
                  error={campos.asunto.error !== ''}
                  helperText={campos.asunto.error}
               />
            </Grid>
            <Grid item xs={4}>
               <FormControl variant="filled" className={clsx(classes.textField)} margin="dense">
                  <InputLabel htmlFor="filled-age-native-simple">Prioridad</InputLabel>
                  <Select
                     value={campos.prioridad.valor}
                     onChange={handleOnChange}
                     inputProps={{
                        name: 'prioridad',
                        id: 'select-prioridad'
                     }}
                  >
                     <MenuItem value={0}>BAJA</MenuItem>
                     <MenuItem value={1}>MEDIA</MenuItem>
                     <MenuItem value={2}>ALTA</MenuItem>
                     <MenuItem value={3}>CRITICA</MenuItem>
                  </Select>
               </FormControl>
            </Grid>
            <Grid container item xs={4}>
               {tiposTicket.length > 0 && (
                  <FormControl variant="filled" className={clsx(classes.textField)} margin="dense">
                     <InputLabel htmlFor="filled-age-native-simple">Tipo de Ticket</InputLabel>
                     <Select
                        value={campos.codTipoTicket.valor}
                        onChange={handleOnChange}
                        inputProps={{
                           name: 'codTipoTicket',
                           id: 'select-prioridad'
                        }}
                     >
                        {tiposTicket.map(tipoTicket => {
                           return (
                              <MenuItem key={tipoTicket.codigo} value={tipoTicket.codigo}>
                                 {tipoTicket.denominacion}
                              </MenuItem>
                           );
                        })}
                     </Select>
                  </FormControl>
               )}
            </Grid>
            <Grid item xs={12}>
               <MUIRichTextEditor
                  value={estadoRte.contenido}
                  onChange={editorChange}
                  label="Describa su consulta"
                  maxLength={200}
               />
            </Grid>
            <Grid container item xs={12}>
               <Grid item xs={6}>
                  <Button
                     onClick={procesarGrabar}
                     variant="contained"
                     color="primary"
                     endIcon={<SendIcon />}
                     disabled={existeError}
                  >
                     Enviar Ticket
                  </Button>
               </Grid>
               <Grid container item xs={6} justify="flex-end">
                  <Button
                     variant="contained"
                     color="secondary"
                     startIcon={<DeleteIcon />}
                     onClick={inicializar}
                  >
                     Limpiar
                  </Button>
               </Grid>
            </Grid>
         </Grid>
      </Container>
   );
}

function mapStateToProps(state) {
   return {
      usuario: state.auth.usuario
   };
}

function mapDispatchToProps(dispatch) {
   return {
      openMsgModal: msg => dispatch(openMsg(msg)),
      openWaitModal: loading => dispatch(loadingModal(loading))
   };
}

export default connect(mapStateToProps, mapDispatchToProps)(AbrirTicket);